import { render, staticRenderFns } from "./PhotoAnnounceHistory.vue?vue&type=template&id=1096d41d"
import script from "./PhotoAnnounceHistory.vue?vue&type=script&lang=ts"
export * from "./PhotoAnnounceHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports